// utils/formatters.js
export const formatBWP = (value) => {
    return `BWP${value.toFixed(2)}`;
  };
  